import { FunctionField, FunctionFieldProps } from 'react-admin';
import Chip from '@mui/material/Chip';
import { makeStyles } from '@mui/styles';

import { UserStatus } from '@types';

export const userStatusOptions = [
  { id: 'active', name: 'Active', color: '#36BE29' },
  { id: 'inactive', name: 'Inactive', color: '#DD482E' },
  { id: 'not_available', name: 'N/A', color: '#a1a1a1' },
];

interface Props {
  autoWidth?: boolean;
  value?: string | UserStatus;
}

export const UserStatusField = (props: Props & Partial<FunctionFieldProps>) => {
  const cls = useStyles();
  const { autoWidth, ...restProps } = props;

  return (
    <FunctionField {...restProps} render={(record: any) => {
      let status: string | UserStatus;

      if (props.source === 'user.status') {
        status = record.user?.status;
      } else {
        status = props.value || record[props.source || 'status'];
      }

      const statusName = userStatusOptions.find(o => o.id === status)?.name;
      const color: any = userStatusOptions.find(o => o.id === status)?.color;

      return record && color ? (
        <Chip
          label={statusName || status}
          size="small"
          style={{
            backgroundColor: color ?? undefined,
            width: autoWidth ? 'auto' : '100%',
            padding: autoWidth ? '5px 15px' : undefined,
          }}
          className={cls.chip}
        />
      ) : null;
    }} />
  );
};

const useStyles = makeStyles({
  chip: {
    color: 'white !important',
    width: 'auto !important',
    lineHeight: 16,
    display: 'inline-flex',
    '& *': {
      color: 'white !important',
      lineHeight: 'normal',
      paddingLeft: 16,
      paddingRight: 16,
    },
  },
});
